import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import Form, { ButtonItem, SimpleItem, EmptyItem, GroupItem, ColCountByScreen, Label } from 'devextreme-react/form'
import JumboCardQuick from '@jumbo/components/JumboCardQuick'
import { useSelector } from 'react-redux'
import Typography from '@mui/material/Typography'
import { IconButton, Stack, useMediaQuery } from '@mui/material'
import WestIcon from '@mui/icons-material/West'

const AddMedicalConditionTypeForm = (props) => {
    const navigate = useNavigate()
    const { handleSubmit } = useForm()
    const { loading } = useSelector((state) => state.medcond)
    const [labelLocation, setLabelLocation] = useState('left')
    const sm = useMediaQuery('(max-width:600px)')

    useEffect(() => {
        setLabelLocation(sm ? 'top' : 'left')
    }, [sm])

    const submitButtonOptions = {
        text: 'Save',
        type: 'default',
        width: 120,
        useSubmitBehavior: true,
    }

    const cancelButtonOptions = {
        text: 'Cancel',
        type: 'Normal',
        width: 120,
        onClick: () =>
            navigate('/settings/definitions/medical-condition-type', {
                state: { navigateFrom: 'cancel-add-medical-condition-type' },
            }),
    }

    const validationRules = {
        name: [{ type: 'required', message: 'Name is required.' }],
    }

    return (
        <React.Fragment>
            <JumboCardQuick
                title={
                    <Stack direction='row' alignItems='center' spacing={1}>
                        <IconButton
                            className='backArrowForm'
                            onClick={() =>
                                navigate(`/settings/definitions/medical-condition-type`, {
                                    state: { navigateFrom: 'cancel-add-medical-condition-type' },
                                })
                            }>
                            <WestIcon />
                        </IconButton>
                        <Typography color={'common.white'} variant={'h3'} sx={{ mt: 0.8 }}>
                            Add medical condition type
                        </Typography>
                    </Stack>
                }
                headerSx={{
                    height: 40,
                    bgcolor: 'primary.main',
                }}>
                <div>
                    <form onSubmit={handleSubmit(props.addMedicalConditionType)}>
                        <Form
                            mode='form'
                            formData={props.medicalConditionTypeData}
                            showColonAfterLabel={false}
                            showValidationSummary={false}
                            labelLocation={labelLocation}>
                            <GroupItem caption='New type' cssClass='form-group-item'>
                                <ColCountByScreen lg={13} md={13} sm={1} xs={1} />
                                <GroupItem />
                                <GroupItem />
                                <GroupItem />
                                <GroupItem cssClass='form-group-item' colSpan={6}>
                                    <EmptyItem />
                                    <SimpleItem dataField='isActive' editorType='dxCheckBox'>
                                        <Label text='Active' />
                                    </SimpleItem>
                                    <SimpleItem dataField='name' validationRules={validationRules.name}>
                                        <Label text='Name' />
                                    </SimpleItem>
                                    <SimpleItem
                                        dataField='displayOrder'
                                        editorType='dxNumberBox'
                                        editorOptions={{ showSpinButtons: true, min: 0 }}>
                                        <Label text='Display order' />
                                    </SimpleItem>
                                </GroupItem>
                            </GroupItem>
                            <GroupItem>
                                <ColCountByScreen lg={2} md={2} sm={1} xs={1} />
                                <GroupItem cssClass='ml-3'>
                                    <ButtonItem
                                        horizontalAlignment='left'
                                        buttonOptions={cancelButtonOptions}
                                        cssClass='mr-3'></ButtonItem>
                                    <ButtonItem
                                        horizontalAlignment='left'
                                        buttonOptions={submitButtonOptions}
                                        cssClass='web-user-create'></ButtonItem>
                                </GroupItem>
                            </GroupItem>
                        </Form>
                    </form>
                </div>
            </JumboCardQuick>
        </React.Fragment>
    )
}

export default AddMedicalConditionTypeForm
